import React, { useState, useEffect } from "react";
import { Card } from "../components/ui/card";
import { ScrollArea } from "../components/ui/scroll-area";
import { Skeleton } from "../components/ui/skeleton";
import Comments from "./Comp/Comments";
import VoteOptions from "./Comp/VoteOptions";
import { useRecoilValue } from "recoil";
import { isUser, userState, voteState } from "../Atom";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../config/Firebase";
import toast from "react-hot-toast";
import moment from "moment";
import Nav from "./Comp/Nav";
import { useNavigate, useParams } from "react-router-dom";

function VotePage() {
  const {voteId} = useParams()
  console.log(voteId)
  const [voteData, setVoteData] = useState({});
  const idVote = useRecoilValue(voteState);
  const [isLoading, setIsLoading] = useState(true);
  const userData = useRecoilValue(userState);
  const user = useRecoilValue(isUser)
  const [commentValue, setCommentValue] = useState("");
  const [voted, setVoted] = useState([]);
  const [updatedOptions, setUpdatedOptions] = useState([]);
  const navigate = useNavigate()

  const voteDetails = async () => {
    const data = await getDocs(collection(db, "Vote"));
    const filteredData = data.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    const tempData = filteredData.filter((item) => item.id === voteId);
    setVoteData(tempData[0]);
    setUpdatedOptions(tempData[0].options);
    setVoted(tempData[0].voted);
  };

  const updateComment = async () => {
    if(!user){
      toast.error("Please login to continue!")
      navigate("/login");
      return;
    }
    if (!commentValue.trim()) return;
    
    const voteRef = doc(db, "Vote", idVote);
    await updateDoc(voteRef, {
      comments: [
        { content: commentValue, userid: userData.name, img: userData.img },
        ...voteData.comments,
      ],
    });
    setCommentValue("");
    voteDetails();
    toast.success("Comment added successfully!");
  };

  const countVote = async (option) => {
    if(!user){
      toast.error("Please login to continue!");
      navigate("/login")
      return;
    }
    if (voted.find((id) => id === userData.id)) {
      toast.error("You have already voted!");
      return;
    }

    const updatedOption = updatedOptions.map(opt => 
      opt === option ? { ...opt, count: opt.count + 1 } : opt
    );
    setUpdatedOptions(updatedOption);

    const countRef = doc(db, "Vote", idVote);
    await updateDoc(countRef, {
      options: updatedOption,
      voted: [...voted, userData.id],
    });

    toast.success("Vote recorded successfully!");
    voteDetails();
  };

  useEffect(() => {
    voteDetails();
    setTimeout(() => setIsLoading(false), 2000);
  }, []);

  return (
    <div className="min-h-screen dark:bg-zinc-950 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
        <Card className="dark:bg-zinc-900/95 bg-white dark:border-zinc-800 border-black/10 shadow-xl">
          <div className="p-6 border-b dark:border-zinc-800 border-black/15">
            {isLoading ? (
              <div className="space-y-4">
                <Skeleton className="h-8 w-2/3 dark:bg-zinc-800/50 bg-gray-200 rounded-xl" />
                <Skeleton className="h-6 w-3/4 dark:bg-zinc-800/50 bg-gray-200 rounded-xl" />
                <Skeleton className="h-6 w-1/3 dark:bg-zinc-800/50 bg-gray-200 rounded-xl" />
              </div>
            ) : (
              <div className="space-y-4 text-start">
                <h1 className="text-2xl font-medium dark:text-zinc-100 text-gray-800">
                  {voteData?.title}
                </h1>
                <p className="dark:text-zinc-300 text-gray-700 text-lg">
                  {voteData?.desc}
                </p>
                <div className="flex items-center gap-2">
                  <div className="h-2 w-2 bg-emerald-500 rounded-full animate-pulse"></div>
                  <span className="dark:text-zinc-400 text-gray-500 text-sm">
                    Ends {moment(voteData?.endDate).format("DD MMM, YYYY")}
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6">
            {/* Voting Options */}
            <div className="space-y-4">
              <h2 className="text-xl font-medium dark:text-zinc-100 mb-6 text-start text-gray-800">Cast Your Vote</h2>
              <div className=" flex flex-wrap gap-4">
                {voteData?.options?.map((option, index) => (
                  <VoteOptions 
                    key={index}
                    option={option} 
                    fun={countVote}
                  />
                ))}
              </div>
            </div>

            {/* Comments Section */}
            <div className="space-y-4">
              <h2 className="text-xl font-medium dark:text-zinc-100 mb-6 text-start text-gray-800">Discussion</h2>
              <div className="space-y-4">
                <div className="relative">
                  <input
                    type="text"
                    value={commentValue}
                    placeholder="Share your thoughts..."
                    className="w-full px-4 py-3 dark:bg-zinc-800/50 border dark:border-zinc-700  bg-gray-200 border-black/10 rounded-lg dark:text-zinc-100 text-gray-800 placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/50 focus:border-emerald-500"
                    onChange={(e) => setCommentValue(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && updateComment()}
                  />
                </div>
                <ScrollArea className="h-[400px]">
                  <div className="space-y-4">
                    {voteData?.comments?.map((item, index) => (
                      <Comments
                        key={index}
                        id={item.userid}
                        content={item.content}
                        img={item.img}
                      />
                    ))}
                  </div>
                </ScrollArea>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default VotePage;